export default __webpack_public_path__ + "static/media/404.b8e96c4d.png";